import React, { memo } from "react"
import { Center } from "@chakra-ui/react"
import Icon from "@app/components/Icon"

type Props = {
  numOfStars: number
}

export const ReviewStarRating: React.FC<Props> = memo(({ numOfStars }) => {
  const flatReview = Math.floor(numOfStars || 0)
  const decimal = Math.abs((numOfStars || 0) - flatReview)

  const stars = Array.from({ length: 5 }, (_, index) => {
    if (flatReview === index) {
      if (decimal < 0.5) {
        return <Icon key={index} name={decimal >= 0.25 ? "reviewStarHalf" : "reviewStarEmpty"} width={5} height={5} />
      }
      return <Icon key={index} name={decimal >= 0.75 ? "reviewStarFull" : "reviewStarHalf"} width={5} height={5} />
    }
    return <Icon key={index} name={flatReview >= index ? "reviewStarFull" : "reviewStarEmpty"} width={5} height={5} />
  })

  return <Center gap={1}>{stars}</Center>
})
